import { createContext, useContext, useState, useCallback } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import EnquiryForm from "@/components/EnquiryForm";

const QuoteContext = createContext({ openQuote: () => {} });

export const useQuote = () => useContext(QuoteContext);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [packageName, setPackageName] = useState(null);

  const openQuote = useCallback((pkg = null) => {
    setPackageName(pkg);
    setOpen(true);
  }, []);

  return (
    <QuoteContext.Provider value={{ openQuote }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto bg-white" data-testid="quote-modal">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl text-[#0F2F24]">Plan Your Kashmir Holiday</DialogTitle>
            <DialogDescription className="text-sm text-slate-600">
              Share a few details and our Kashmir travel expert will send you a personalised quote.
            </DialogDescription>
          </DialogHeader>
          <EnquiryForm packageName={packageName} source="quote-modal" onSuccess={() => setOpen(false)} testIdPrefix="quote-modal" />
        </DialogContent>
      </Dialog>
    </QuoteContext.Provider>
  );
};
